import { Form, Stack } from "react-bootstrap";
import { orderAtom } from "../atoms/atoms";
import { useAtom, useSetAtom } from "jotai";
import { useState } from "react";

const CustomerAddress = () => {
    //     city
    // postcode
    // address
    const [city, setCity] = useState("");
    const [postcode, setPostcode] = useState("");
    const [address, setAddress] = useState("");

    const setOrder = useSetAtom(orderAtom);

    const onCityChange = (e) => {
        setCity(e.target.value);
        setOrder((prev) => ({
            ...prev,
            city: e.target.value,
        }));
    }

    const onPostcodeChange = (e) => {
        setPostcode(e.target.value);
        setOrder((prev) => ({
            ...prev,
            postcode: e.target.value,
        }));
    }

    const onAddressChange = (e) => {
        setAddress(e.target.value);
        setOrder((prev) => ({
            ...prev,
            address: e.target.value,
        }));
    }

    return (
        <>
            <div className="row">
                <div className="col-12 col-md-6">


                    <Form.Group className="mb-1" controlId="formPostcode">
                        <Form.Label>Kod pocztowy</Form.Label>
                        <Form.Control
                            onChange={(e) => onPostcodeChange(e)}
                            value={postcode}
                            maxLength="6"
                            type="text"
                            placeholder="Kod pocztowy"
                            autoComplete="" />
                    </Form.Group>
                </div>
                <div className="col-12 col-md-6">

                    <Form.Group className="mb-1" controlId="formCity">
                        <Form.Label>Miasto:</Form.Label>
                        <Form.Control
                            onChange={(e) => onCityChange(e)}
                            value={city}
                            maxLength="200"
                            type="text"
                            placeholder="Miasto"
                            autoComplete="" />
                    </Form.Group>
                </div>
            </div>
            <div className="row">
                <div className="col-12 ">
                    <Form.Group className="mb-3" controlId="formAddress">
                        <Form.Label>Adres:</Form.Label>
                        <Form.Control
                            onChange={(e) => onAddressChange(e)}
                            value={address}
                            maxLength="200"
                            type="text"
                            placeholder="Adres"
                            autoComplete="" />
                    </Form.Group>
                </div>
            </div>
        </>
    )
}

export default CustomerAddress;